import { getActiveProfile } from './getActiveProfile';
import { getProfileLayoutById } from './getProfileLayoutById';
import { getProfileLayoutByColumnsLength } from './getProfileLayoutByColumnsLength';

export const profiles = {
  getActiveProfile,
  getProfileLayoutByColumnsLength,
  getProfileLayoutById,
};
